import { ReactNode } from 'react';
import { Step as MUIStep, StepProps as MUIStepProps } from '@mui/material';

type AtomMUIProps = {
  children?: ReactNode;
};

export type StepProps = AtomMUIProps;

export const Step = (props: StepProps) => {
  const MUIProps: MUIStepProps = props;

  return <MUIStep {...MUIProps} />;
};

export default Step;
